<template>
  <div class="content compliance-content">
    <div class="columns overview-product-header">
      <div class="column content-name"></div>
      <div class="column content-name fees">
        Sold Units/Fees
      </div>
    </div>
    <div
      class="columns overview-product-content"
      v-for="(value, index) in contentData"
      :key="index"
    >
      <div class="column product-name">
        {{ value.name }} ( {{ value.product_number }} )
      </div>

      <div class="column content-name fees">
        {{ value.sales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} /
        {{ value.total_fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}
        {{ value.currency ? value.currency : "EUR" }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ComplianceOverviewProductContent",
  props: {
    data: []
  },
  data() {
    return {
      contentData: this.data
    };
  },
  watch: {
    data(newVal) {
      this.contentData = newVal;
    }
  }
};
</script>
